export default __webpack_public_path__ + "static/media/557.452d2b52.png";